import React from 'react';
import { ErrorBoundary } from '@components/common';
import { ManagementProvider } from './store';
import Main, { type ManagementProps } from './Main';

const Management = (props: ManagementProps) => {
  return (
    <ErrorBoundary>
      <ManagementProvider {...props}>
        <Main {...props} />
      </ManagementProvider>
    </ErrorBoundary>
  );
};

export default React.memo(Management);
export type { ManagementProps };
